import RandomWord from '../data/RandomWord';
import { useEffect , useState } from 'react';
import {useFetch} from '../hooks/useFetch'

import '../styles/SimilarTo.css'

export default function SimilarTo() {
    const [word , setWord] = useState('');
    const {data : similarWord } = useFetch(`https://api.datamuse.com/words?ml=${word}`)

    const [options , setOptions ]= useState([]);

    const [gameOver , setGameOver ] = useState(false)
    const [score , setScore ] = useState(0)

    useEffect(()=> {
      const rWord = RandomWord()
      setWord(rWord) 
      
      setOptions([RandomWord() , RandomWord() , RandomWord()])

    } , [])

    if(similarWord) {
      /*   console.log('SIMILAR WORD ' , similarWord[0].word) */
     /*    console.log(options) */
    }
    const checkAns = (e) => {
        let selectedAns = e.target.textContent.trim().toLowerCase();
        if(selectedAns === similarWord[0].word) {
            const rWord = RandomWord()
            setWord(rWord) 
            setOptions([RandomWord() , RandomWord() , RandomWord()])

            setScore(score + 1);
           
            
        }else {
            setGameOver(true)
        }
    }

    /* https://api.datamuse.com/words?ml=ringing+in+the+ears */
  return (
    <div className='SimilarTo'>
        <h1>Similar To </h1>
        <div className="SimilarTo-container">
            {word && similarWord && !gameOver && 
            <div className='game-s-2'>
                
                <h1>{word}</h1>
                <h3>score : {score}</h3>
                <p>Select the similar word</p>
                <div className='game-options-2'>
                    {[...options, similarWord[0].word].sort(() => Math.random() - 0.5)
                        .map((element , index)=> {
                            return <button key={index} onClick={(e)=> checkAns(e)}>
                                        {element}
                                    </button>
                })}
                    
                </div>
            </div>}
        </div>
    
        {gameOver && 
            <div className='gameover-2'>
                <h1>Gameover</h1>
                <h3> score :  {score}</h3>
                <p>the similar word to <span>{word}</span>  was <span>{similarWord[0].word}</span></p>
                <button onClick={()=>  window.location.reload()}>try again</button>
            </div>}

    </div>
  )
}
